// Globals
import { useEffect } from 'react';

// Store
import { useAppDispatch, useAppState } from '@/store';
import {
  getDeliverySettings,
  selectDeliverySettings,
  selectDeliverySettingsError,
  selectDeliverySettingsIsLoading,
} from '../feature';

export const useGetDeliverySettings = (channelId?: number) => {
  const deliverySettings = useAppState(selectDeliverySettings);
  const isLoading = useAppState(selectDeliverySettingsIsLoading);
  const error = useAppState(selectDeliverySettingsError);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!channelId || !!deliverySettings || isLoading || !!error) return;
    dispatch(getDeliverySettings({ channelId }));
  }, [deliverySettings, channelId, isLoading, error, dispatch]);

  return {
    deliverySettings,
    isLoading,
    error,
  };
};
